import React from 'react'
import { withFirebase } from '../Fb'

// reactstrap components
import {
  Row,
  Col
} from 'reactstrap'
import ProshopProducts from '../Lists/ProshopProducts'
import ProshopBrands from '../Lists/ProshopBrands'
import ProshopInfo from './ProshopInfo'
import ProshopProductCategories from '../Lists/ProshopProductCategories'
const service = 'proshop'
// core components



class ProshopContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      saving: false,
      enabled: false,
      refreshKey: 0,
    }
  }

  notifyDataChanged = () => {
    this.setState((s) => ({ refreshKey: s.refreshKey + 1 }))
  }

  componentDidMount() {
    if (this.props.modules && this.props.modules[service] && this.props.modules[service].enabled) {
      this.setState({ enabled: true })
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.modules && this.props.modules[service]) {
      // modules is null until it has loaded, so prevProps.modules needs the same guard as
      // this.props.modules - without it a hard page load throws here.
      if (this.props.modules[service].enabled && !prevProps.modules?.[service]?.enabled) {
        this.setState({ enabled: true })
      }
      if (!this.props.modules[service].enabled && prevProps.modules?.[service]?.enabled) {
        this.setState({ enabled: false })
      }
    } else {
      if(this.state.enabled) {
        this.setState({ enabled: false })
      }
    }
  }

  enableModule = async (price) => {
    this.setState({ saving: true })
    await this.props.firebase.enableModule(service, price)
  }

  render() {
    if (!this.state.enabled) {
      return (
        <>
          <div className='content'>
            <Row>
              <Col md='12'>
                <ProshopInfo onSubmit={this.enableModule} saving={this.state.saving} />
              </Col>
            </Row>
          </div>
        </>
      )
    } else {
      return (
        <>
          <div className='content'>
            <Row>
              <Col md='9'>
                <ProshopProducts {...this.props} refreshKey={this.state.refreshKey} />
              </Col>
              <Col md='3'>
                <Row>
                  <Col xs='12'>
                    <ProshopBrands {...this.props} onDataChanged={this.notifyDataChanged} />
                  </Col>
                  <Col xs='12'>
                    <ProshopProductCategories {...this.props} onDataChanged={this.notifyDataChanged} />
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </>
      )
    }
  }
}

export default withFirebase(ProshopContainer)
